.animated-background {
  --abg-color-1: #1d1ba7;
  --abg-color-2: #235fd7;
  --abg-base: #ffffff;
  --abg-duration: 10s;
  --abg-tint-1: 10%;
  --abg-tint-2: 10%;
  --abg-spot1-size: 45%;
  --abg-spot2-size: 50%;
  --abg-vignette-opacity: 1;

  --g2-1-x-position: 87.96875%;
  --g2-1-y-position: 91.1328125%;
  --g2-2-x-position: 13.3984375%;
  --g2-2-y-position: 82.734375%;

  background:
    radial-gradient(
      40% 40% at 8% 8%,
      rgba(255, 255, 255, var(--abg-vignette-opacity)) 0%,
      transparent 60%
    ),
    radial-gradient(
      var(--abg-spot1-size) var(--abg-spot1-size) at var(--g2-1-x-position) var(--g2-1-y-position),
      color-mix(in srgb, var(--abg-color-1) var(--abg-tint-1), transparent),
      transparent 70%
    ),
    radial-gradient(
      var(--abg-spot2-size) var(--abg-spot2-size) at var(--g2-2-x-position) var(--g2-2-y-position),
      color-mix(in srgb, var(--abg-color-2) var(--abg-tint-2), transparent),
      transparent 70%
    ),
    var(--abg-base);
  animation-name: abg-move;
  animation-iteration-count: infinite;
  animation-duration: var(--abg-duration);
  transition-timing-function: ease-in-out;
}

@property --g2-1-x-position {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 87.96875%;
}
@property --g2-1-y-position {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 91.1328125%;
}
@property --g2-2-x-position {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 13.3984375%;
}
@property --g2-2-y-position {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 82.734375%;
}

@keyframes abg-move {
  50% {
    --g2-1-x-position: 15%;
    --g2-1-y-position: 15%;
    --g2-2-x-position: 61.2109375%;
    --g2-2-y-position: 13.75%;
  }
}
